export const ARTIST_BIO_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ArtistBioWidgetElement';
